export default __webpack_public_path__ + "static/media/gradient.6361e452.gif";